var styles = {"cta":"styles_cta__1z5hj p2 center bold block","active-cta":"styles_active-cta__1mMnD","activeCta":"styles_active-cta__1mMnD"};

export default styles;
//# sourceMappingURL=styles.css.js.map
